<template>
  <a-modal :title="readonly ? '查看' : '编辑'" v-model="modalShow" width="80%" :class="{ 'footer-none': btns.length == 0 }"
    @cancel="close" destroyOnClose>

    <a-form-model class="common-form-inline" :rules="ruleForm" ref="ruleForm" :model="pageData" :label-col="{ span: 7 }"
      :wrapper-col="{ span: 13 }">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="卖方名称" prop="sellrName">
            <span>{{ pageData.sellrName }}</span>
            <!-- <div v-if="readonly" class="img-tip"><span>{{pageData.sellrName}}</span><span style="margin-left:16px;">{{pageData.sellrOrgCode}}</span></div>
                          <select-search
                              v-show="!readonly"
                              v-model="tenantObj"
                              :searchSource="true"
                              :dataSource="tenantOption"
                              headNameFirst="卖方名称"
                              headNameSecond="社会信用代码"
                              valuePorp="orgCode"
                              labelPorp="userName"
                              @handleChange="changeTenant"
                              @handleSearch="handleSearch"
              ></select-search>-->
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="发票上传" prop="tblBlId" style="margin-bottom:30px">
            <imgUpload style="height:110px;" :disabled="readonly" @remove="removeOk" :file="pageData.file"
              :paramObj="uploadParam" @uploadOk="uploadOk" name="file"></imgUpload>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="发票类型" prop="invoiceType" style="margin-top:-10px;">
            <a-select v-model="pageData.invoiceType" :allowClear="true" style="width:100%" :disabled="readonly"
              @change="invTypeChange">
              <a-select-option v-for="item in invoiceTypes" :key="item.dctVal" :value="item.dctVal"
                :label="item.dctValNm">{{ item.dctValNm }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item v-if="pageData.invoiceType == 4" label="发票代码">
            <a-input v-model="pageData.invoiceCode" placeholder="请输入" :disabled="true" />
          </a-form-model-item>
          <a-form-model-item v-else label="发票代码" prop="invoiceCode">
            <a-input v-model="pageData.invoiceCode" placeholder="请输入" :disabled="readonly" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="发票号码" prop="invoiceNumber">
            <a-input v-model="pageData.invoiceNumber" placeholder="请输入" :disabled="readonly" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="开票日期" prop="billTime">
            <a-date-picker v-model="pageData.billTime" placeholder="请输入" :disabled="readonly" valueFormat="YYYY-MM-DD"
              style="width:100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="pageData.invoiceType == 2 || pageData.invoiceType == 3">
          <a-form-model-item label="发票校验码后六位" prop="checkCode">
            <a-input v-model="pageData.checkCode" placeholder="请输入" :disabled="readonly" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="pageData.invoiceType == 0 || pageData.invoiceType == 1 || pageData.invoiceType == 4">
          <a-form-model-item label="发票金额" prop="invoiceAmount">
            <a-input v-model="pageData.invoiceAmount" placeholder="请输入" type="number" :disabled="readonly"
              addon-after="(不含税)元" class="myinput" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="发票金额" prop="invoiceAmountWithVat">
            <a-input v-model="pageData.invoiceAmountWithVat" placeholder="请输入" type="number" :disabled="readonly"
              addon-after="(含税)元" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col :span="12">
            <a-form-model-item label="应付金额" prop="payableAmount">
              <a-input v-model="pageData.payableAmount" placeholder="请输入" type="number" :disabled="readonly"
                addon-after="元" />
              <span class="text-color-orange">应付金额应为当前发票的未偿付部分</span>
            </a-form-model-item>
          </a-col> -->
      </a-row>
    </a-form-model>
    <div style="font-size: 16px;font-weight: bold; margin-bottom: 10px;">祺信列表</div>
    <a-table :pagination="false" :columns="columns" :data-source="tableData" bordered
      :locale="{ emptyText: '暂无数据' }">
      <template slot="gldId" slot-scope="text, record">
        <a>{{ text }}</a>
      </template>
      <template slot="gldAmt" slot-scope="text, record">
        <div>{{ text }}</div>
      </template>
      <template slot="estbDay" slot-scope="text, record">
        <div>
          {{ text | formatDate }}
        </div>
      </template>
    </a-table>
    <div style="margin-top: 15px;" :class="{
      'table-total': pagination.total > 0,
      'table-total-none': pagination.total == 0
    }">
      记录：
      <span class="text-color-blue"> {{ tableData.length }} 条 </span>
      祺信金额(元)：
      <span class="text-color-orange">
        {{ totalPayable(tableData) | splitK }} 元
      </span>
    </div>

    <template slot="footer">
      <a-button v-if="btns.indexOf('close') > -1" class="btn-blue-line" @click="close()">取消</a-button>
      <button-load v-if="btns.indexOf('save') > -1" @clickHandle="save" type="primary" lable="保存" />
      <button-load v-if="btns.indexOf('save2') > -1" @clickHandle="handleSave" type="primary" lable="保存" />
    </template>
  </a-modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import imgUpload from '@/components/ui/img-upload/img-upload'
import {
  invGetById,
  getQRCodeInfo,
  updateById,
  go2Check,
  getBaseAsset,
  invoiceSave,
} from '@/api/payable.js'
import { selectSellerCst } from '@/api/rcvbBuy.js'
import { fileSaveAPI } from '@/api/file.js'
import { mapActions } from 'vuex'
export default {
  props: {
    info: {
      type: [Object],
      default: function () {
        return {}
      },
    },
    btns: {
      type: Array,
      default() {
        //close、check、save
        return []
      },
    },
    readonly: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  components: { imgUpload },
  name: 'invoice-info-dialog',
  data() {
    return {
      modalShow: false,
      confirmLoading: false,
      uploadParam: {
        app: 'portal-pc',
        module: 'payable',
        user: this.$store.getters['home/getUserHeader'].realname,
        tblBlId: this.utils.guid(32, 16),
        mdlId: 'payable',
      },
      tenantObj: {},
      tenantOption: [],
      pageData: {
        file: null,
        tblBlId: undefined,
      },
      ruleForm: {
        sellrName: [
          { required: true, message: '卖方名称不能为空', trigger: 'change' },
        ],
        tblBlId: [
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, cbfn) => {
              if (!this.pageData.file) {
                cbfn('请上传发票')
              } else {
                cbfn()
              }
            },
          },
        ],
        invoiceType: [
          { required: true, message: '发票类型不能为空', trigger: 'blur' },
        ],
        invoiceCode: [
          { required: true, message: '发票代码不能为空', trigger: 'change' },
        ],
        invoiceNumber: [
          { required: true, message: '发票号码不能为空', trigger: 'blur' },
        ],
        billTime: [
          { required: true, message: '开票日期不能为空', trigger: 'blur' },
        ],
        invoiceAmountWithVat: [
          {
            required: true,
            message: '发票金额（含税）不能为空',
            trigger: 'blur',
          },
        ],
        invoiceAmount: [
          {
            required: true,
            message: '发票金额（不含税）不能为空',
            trigger: 'blur',
          },
        ],
        checkCode: [
          {
            required: true,
            message: '发票校验码后六位不能为空',
            trigger: 'blur',
          },
        ],
        // payableAmount: [
        //   {
        //     required: true,
        //     trigger: 'change',
        //     validator: (rule, value, cbfn) => {
        //       if (!this.pageData.payableAmount) {
        //         cbfn('应付金额不能为空')
        //       } else if (
        //         this.pageData.payableAmount > this.pageData.invoiceAmountWithVat
        //       ) {
        //         cbfn('应付金额不能大于发票金额（含税）')
        //       } else {
        //         cbfn()
        //       }
        //     },
        //   },
        // ],
      },
      invoiceTypes: [],
      columns: [
        {
          title: '祺信编号',
          dataIndex: 'gldId',
          scopedSlots: { customRender: 'gldId' },
          key: 'gldId'
        },
        {
          title: '祺信金额',
          dataIndex: 'gldAmt',
          scopedSlots: { customRender: 'gldAmt' },
          key: 'gldAmt'
        },
        {
          title: '开立日期',
          dataIndex: 'estbDay',
          scopedSlots: { customRender: 'estbDay' },
          key: 'estbDay'
        },
      ],
      tableData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
        showTotal: total => {
          return `共 ${total} 条`;
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      userObj: 'home/getUserObj',
    }),
  },
  created() {
    this.getDicAsync('InvoiceType').then((res) => {
      this.invoiceTypes = res
    })
  },
  methods: {
    ...mapActions({
      getDicAsync: 'app/getDicAsync',
    }),
    open() {

      this.$nextTick(() => {
        if (this.info && this.info.id) {
          this.getInfo()
        } else {
          this.pageData = this.info
          console.log(this.pageData)
          this.modalShow = true
        }
      })

    },
    // 计算表格勾选合计
    totalPayable(list, key = "gldAmt") {
      return list.reduce((acc, rec) => {
        return acc + (+rec[key] || 0);
      }, 0);
    },
    getInfo() {
      if (this.info && this.info.docId) {
        getBaseAsset({ docId: this.info.docId, cyCode: this.info.rcvbId }).then((res) => {
          res.data.file = res.data.file || null
          this.pageData = res.data || {}
          this.$set(this.pageData, 'payableAmount', res.data.payableAmount || res.data.invoiceAmountWithVat || 0)
          this.modalShow = true
          this.tenantObj = {
            key: this.pageData.sellrOrgCode,
            label: this.pageData.sellrName,
          }
        })
      } else {
        invGetById({ id: this.info && this.info.id }).then((res) => {
          res.data.file = res.data.file || null
          this.pageData = res.data || {}
          this.tableData = res.data.gldList || []
          this.$set(this.pageData, 'payableAmount', this.info.payableAmount)
          this.modalShow = true
          this.tenantObj = {
            key: this.pageData.sellrOrgCode,
            label: this.pageData.sellrName,
          }
        })
      }
    },
    close() {
      this.modalShow = false
      this.pageData = {}
      this.$refs.ruleForm.resetFields()
    },
    invTypeChange(val) {
      if (+val === 0 || +val === 1) {
        //专票
        this.ruleForm.checkCode = {}
        this.ruleForm.invoiceAmount = [
          {
            required: true,
            message: '发票金额（不含税）不能为空',
            trigger: 'blur',
          },
        ]
      } else if (+val === 2 || +val === 3) {
        // this.ruleForm.invoiceAmount = {}
        this.ruleForm.checkCode = [
          {
            required: true,
            message: '发票校验码后六位不能为空',
            trigger: 'blur',
          },
        ]
      }
      if (this.pageData.invoiceType == 4) {
        this.pageData.invoiceCode = ''

      }
    },
    // 删除文件
    removeOk() {
      this.pageData.file = null
      this.pageData.tblBlId = undefined
    },
    getQRCodeInfo(tblBlId) {
      getQRCodeInfo({ tblBlId: tblBlId }).then((res) => {
        if (!res.data) {
          this.$confirm({
            title: '发票OCR识别失败',
            content: '请上传清晰发票影像或手工输入发票信息',
            onOk() { },
            onCancel() { },
          })
          return
        }
        let resData = res.data || {}
        for (let k in resData) {
          this.$set(this.pageData, k, resData[k])
          this.tenantObj = {
            key: this.pageData.sellrOrgCode,
            label: this.pageData.sellrName,
          }
        }
      })
    },
    fileSave(data) {
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.uploadParam.tblBlId,
        mdlId: 'payable',
      }
      fileSaveAPI(param)
        .then((res) => {
          this.uploading = false
          this.pageData.tblBlId = this.uploadParam.tblBlId
          this.uploadParam.tblBlId = this.utils.guid(32, 16)
          this.pageData.file = data
          this.getQRCodeInfo(this.pageData.tblBlId)
          this.$refs.ruleForm && this.$refs.ruleForm.validateField('tblBlId')
        })
        .catch((err) => {
          this.uploading = false
          console.log(err)
        })
    },
    uploadOk(resList) {
      this.fileSave(resList[0])
    },
    // 卖方名称选项
    handleSearch(value, data) {
      selectSellerCst({
        pageSize: 10,
        effStCd: 1,
        statusCode: 0,
        state: 2,
        userName: value || '',
        pageNum: 1,
      })
        .then((res) => {
          this.tenantOption = res.data.grid.list
        })
        .catch((error) => {
          console.log(error)
        })
    },
    changeTenant(data, node) {
      node = node || {}
      this.pageData.sellrName = node.userName
      this.pageData.sellrOrgCode = node.orgCode
      this.pageData.tenantId = node.tenantId
      this.$refs.ruleForm && this.$refs.ruleForm.validateField('sellrName')
    },
    save(btn) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.pageData.docTpCd = '2'
          updateById({
            ...this.pageData,
            canEstbGldBal: this.pageData.payableAmount,
          }).then((res) => {
            this.$message.success('操作成功')
            btn && btn.closeLoad()
            this.close()
            this.$emit('success')
          })
        } else {
          btn && btn.closeLoad()
        }
      })
    },
    handleSave(btn) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.pageData.docTpCd = '2'
          if (this.pageData.id) {
            updateById({
              ...this.pageData,
              canEstbGldBal: this.pageData.payableAmount,
            }).then((res) => {
              this.$emit('success', res.data)
              this.$message.success('操作成功')
              btn && btn.closeLoad()
              this.close()
            }).catch((err) => {
              btn && btn.closeLoad()
            })
          } else {
            invoiceSave({
              ...this.pageData,
              tblBlId: this.pageData.tblBlId,
              invoiceId: this.pageData.fileId,
              canEstbGldBal: this.pageData.payableAmount,
            })
              .then((res) => {
                this.$emit('success', res.data)
                this.$message.success('操作成功')
                btn && btn.closeLoad()
                this.modalShow = false
                this.close()
              })
              .catch((err) => {
                btn && btn.closeLoad()
              })
          }
        } else {
          btn && btn.closeLoad()
        }
      })
    },
    check(btn) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            cyCodeList: this.pageData.cyCode,
          }
          go2Check(params)
            .then((res) => {
              this.$message.success('操作成功')
              this.$emit('check')
              this.close()
              btn.closeLoad()
            })
            .catch((err) => {
              btn.closeLoad()
            })
        } else {
          btn && btn.closeLoad()
        }
      })
    },
  },
  watch: {
    info(newVal) {
      // if(newVal&&newVal.id){
      //     this.getInfo();
      // }
    },
  },
    filters: {
      // 格式化日期 去掉时分秒
  formatDate(value) {
    if (!value) return ''
    return value.split(' ')[0]
  }
},
  activated() { },
}
</script>
<style scoped lang="less">
.img-tip {
  white-space: nowrap;
}

/deep/ .ant-input-group-addon {
  border: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/payable/invoice-info-dialog.vue